module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter"
  }, [_c('search'), _vm._v(" "), _c('favorited-searches', {
    attrs: {
      "collapsable": _vm.collapsable
    }
  }), _vm._v(" "), _vm._l((_vm.filters), function(filter) {
    return _c('div', [_c('checkboxes', {
      attrs: {
        "label": filter.label,
        "items": filter.items,
        "model": filter.model,
        "prefix": filter.name,
        "collapsable": _vm.collapsable,
        "type": filter.filterDefinition.type
      },
      on: {
        "updated": function (value) { return filter.model = value; }
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "export"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.exportFilterVisible),
      expression: "!exportFilterVisible"
    }],
    on: {
      "click": function($event) {
        _vm.exportFilterVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("content_paste")]), _vm._v(" Export filter\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exportFilterVisible),
      expression: "exportFilterVisible"
    }]
  }, [_c('i', {
    staticClass: "material-icons clickable",
    on: {
      "click": function($event) {
        _vm.exportFilterVisible = false
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "exportable"
  }, [_vm._v(_vm._s(_vm.exportable))])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v(" Import filter")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39421520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Filters.vue
// module id = 548
// module chunks = 1